/**
 * スペースに関する定数
 * バックエンドの Space モデルの定数と対応している
 */

/**
 * スペースタイプ
 */
export const SPACE_TYPE = {
  PRIVATE_ROOM: 'private_room',
  SHOWER_ROOM: 'shower_room',
} as const;

export type SpaceType = (typeof SPACE_TYPE)[keyof typeof SPACE_TYPE];

/**
 * スペースのキータイプ
 */
export const KEY_TYPE = {
  DIGITAL: 'digital',
  PHYSICAL_KEY_ONLY: 'physical_key_only',
} as const;

export type KeyType = (typeof KEY_TYPE)[keyof typeof KEY_TYPE];

/**
 * 予約時間単位（分）
 */
export const RESERVABLE_TIME_UNIT_IN_MINUTES = {
  [SPACE_TYPE.PRIVATE_ROOM]: 5, // 防音個室ブース: 5分単位
  [SPACE_TYPE.SHOWER_ROOM]: 30, // シャワールーム: 30分単位
} as const;

/**
 * 最大利用時間（分）
 */
export const MAX_RESERVATION_TIME_LENGTH_IN_MINUTES = {
  [SPACE_TYPE.PRIVATE_ROOM]: 70, // 防音個室ブース: 最大70分
  [SPACE_TYPE.SHOWER_ROOM]: 30, // シャワールーム: 最大30分
} as const;
